module.exports = __webpack_public_path__ + "img/npxs.22c8a0c5.svg";